// import * as React from 'react';
import React, { useState } from 'react';

import Alert from '@mui/material/Alert';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
// ServiceForm
import ServiceForm from './ServiceForm';

const serviceCreate = () => {
    const [alertError, setAlertError] = useState({});

    const handleAlertError = (message) => {
        setAlertError(message);
    }

    return (

        <Container component="div" maxWidth="md">
            <CssBaseline />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography component="h1" variant="h5">
                    Create Service
                </Typography>

                <>
                    {
                        Object.keys(alertError).length !== 0 ?
                            <Alert 
                            severity="error"
                            sx={{m: 3}}
                            >
                                {alertError}
                            </Alert>
                        : null
                    }
                </>

                <ServiceForm service={null} handleError={handleAlertError} />

            </Box>

        </Container>
    );
}

export default serviceCreate;